import React from "react";
import SMARTLEND from "../../../assets/SMARTLEND.png";
import Avatar from "../../../components/common/Avatar";
import {SearchIcon} from "../../../components/common/IconComponents"
import { Link } from "react-router-dom";


function CreateModelHeader(){

    return(
        <div className="flex justify-between mt-2 items-center border-b-2 border-gray-200 border-solid pb-3 mx-4">
            <div className="xl:ml-4 md:m-4 sm:ml-1">
                <Link to={"/"}><img src={SMARTLEND} alt="logo w-[201px] h-[35px]"/></Link>
            </div>

            <div className="flex items-center">
                <div className="relative ml-6">
                    <input type='text'
                        id='seach' 
                        role='search' 
                        placeholder='Search' 
                        className=' sm:w-[350px] md:w-[400px] xl:w-[490px] py-1 pl-8 pr-4 border border-gray-300 rounded-3xl'
                    
                    />
                    <spam className="absolute inset-y-0 left-0 pl-1 flex items-center pointer-events-none">
                        <SearchIcon className="h-4 w-4 text-gray-500" />
                    </spam>
                </div>
                <span className="w-8 h-10 rounded-full mr-6 ml-6">
                    <Avatar />
                </span>
            </div>

        </div>
    )

}

export default CreateModelHeader;